import {
  dateOperatorSchema,
  stringOperatorSchema,
  numberOperatorSchema,
} from "../operations/operation-filter";
import { z } from "zod";

export const filterCouponSchema = z.object({
  code: stringOperatorSchema.optional(),
  reduction: numberOperatorSchema.optional(),
  userId: stringOperatorSchema.optional(),
  startDate: dateOperatorSchema.optional(),
  endDate: dateOperatorSchema.optional(),
  rateId: stringOperatorSchema.optional(),
  type: numberOperatorSchema.optional(),
  status: numberOperatorSchema.optional(),
});

export type FilterCouponType = z.infer<typeof filterCouponSchema>;
